import { clsx } from "clsx";
import React, {
  type DetailedHTMLProps,
  type HTMLAttributes,
  type PropsWithChildren,
  type ReactNode,
} from "react";
import { SmallRippleSpinner } from "../../RippleSpinner";
import Styles from "./PermissionsRow.module.css";

export interface PermissionsRowProps {
  containerProps?: DetailedHTMLProps<
    HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >;
  isLoading?: boolean;
  label: ReactNode;
}

export const PermissionsRow = ({
  children,
  containerProps = {},
  isLoading,
  label,
}: PropsWithChildren<PermissionsRowProps>) => {
  const { className: containerClassName, ...props } = containerProps;
  return (
    <div className={clsx(Styles.permissionRow, containerClassName)} {...props}>
      <div className="truncate">{label}</div>
      <div className={Styles.content}>
        <span
          className={clsx(Styles.spinnerContainer, Styles.visibilityContainer, {
            visible: isLoading,
          })}
        >
          <SmallRippleSpinner />
        </span>
        {children}
      </div>
    </div>
  );
};
